import { ControllerHelper, UserController, UserSearchDto, UserShortInfoDownloadDto } from 'collaboration-service';
import { FacetResult } from 'collaboration-service/dist/dtos/FacetResult';
import { components, GroupBase, ImgOnChangeValue, ImgSelect, OptionProps, SingleValueProps } from "imaginarity-react-ui";
import _ from 'lodash';
import * as React from 'react';
import { getTranslatedUserName } from 'services/Helpers/TranslationHelpers';
import { SelectCount, SelectElementContainerWithCount } from './SelectHelpers/SelectHelpers';
import UserTile from './UserSearch/UserTile';

export interface UserWithCount extends UserShortInfoDownloadDto {
    count?: number;
}

export interface UserSelectProps<IsMulti extends boolean> {
    value?: ImgOnChangeValue<UserWithCount, IsMulti, true>;    // previous value
    list?: string[];
    usersSelected?: (val: ImgOnChangeValue<UserWithCount, IsMulti, true>) => void;
    showAvatar?: boolean;
    showEmail?: boolean;
    darkMode?: boolean;
    toHide?: string[];
    searchInfo?: Partial<UserSearchDto>;
    isDisabled?: boolean;
    linkToProfile?: boolean;
    isMulti: IsMulti;
    counts?: FacetResult[];
    menuPortalTarget?: HTMLElement | null;
}

export interface UserSearchState {
    selectedUsers: UserWithCount | UserWithCount[];
}

// type AsyncUserSelecT = new () => ImgAsyncSelect<SelectData>;
// const AsyncUserSelect = ImgAsyncSelect as AsyncUserSelecT;


const UserSelect = <IsMulti extends boolean = false>(p: UserSelectProps<IsMulti>) => {
    const { list, value, usersSelected, showAvatar, isMulti, isDisabled, showEmail, linkToProfile, counts, menuPortalTarget } = p;
    const root = React.useMemo(() => document.getElementById("root"), []);
    const [userList, setUserList] = React.useState<UserWithCount[]>([]);

    //const filter = React.useMemo(() => (o: any, inputValue: string) => toHide === undefined || _.findIndex(toHide, h => o.data.data.id === h) < 0, [toHide]);
    const { changeOption, singleValue } = React.useMemo(() => {
        return {
            changeOption: (p: OptionProps<UserWithCount, IsMulti, GroupBase<UserWithCount>>) => {
                const { data } = p;
                const { count } = data;
                return (
                    <components.Option {...p}>
                        {(count ?? 0) > 0 ?
                            <SelectElementContainerWithCount>
                                <UserTile user={data} showAvatar={showAvatar} showEmail={showEmail} linkToProfile={linkToProfile ?? false} />
                                <SelectCount style={{ paddingTop: 5 }}>
                                    {count}
                                </SelectCount>
                            </SelectElementContainerWithCount>
                            :
                            <UserTile user={data} showAvatar={showAvatar} showEmail={showEmail} linkToProfile={linkToProfile ?? false} />

                        }
                    </components.Option>
                )
            },
            singleValue: (p: SingleValueProps<UserWithCount, IsMulti, GroupBase<UserWithCount>>) => {
                const { data } = p;
                const { count } = data;
                return (
                    <components.SingleValue {...p}>
                        {(count ?? 0) > 0 ?
                            <SelectElementContainerWithCount>
                                <UserTile user={data} showAvatar={showAvatar} showEmail={showEmail} linkToProfile={linkToProfile ?? false} />
                                <SelectCount style={{ paddingTop: 5 }}>
                                    {count}
                                </SelectCount>
                            </SelectElementContainerWithCount>
                            :
                            <UserTile user={data} showAvatar={showAvatar} showEmail={showEmail} linkToProfile={linkToProfile ?? false} />

                        }
                    </components.SingleValue>
                )
            },
        }
    }, [showAvatar, showEmail, linkToProfile]);

    const su = React.useMemo(() => (users: UserWithCount[]) => {
        const u = _.map(users, u => ({ ...u, count: _.find(counts, c => c.data === u.id)?.count ?? 0 }));

        setUserList(_.reverse(_.sortBy(_.reverse(_.sortBy(u, uu => getTranslatedUserName(uu))), uu => uu.count)));
    }, [setUserList, counts]);

    React.useEffect(() => {
        const l = async () => {
            if (list) {
                const res = await ControllerHelper.singleCall({ ids: list }, UserController.GetUserInfoByUserIds);
                su(res);
            }
            else {
                su([]);
            }
        }
        l();
    }, [list, su]);

    const curValue = React.useMemo(() => value ? (_.isArray(value) ?
        _.map(value, u => _.find(userList, l => l.id === u.id))
        : _.find(userList, l => l.id === value.id)
    ) : null, [value, userList]);

    return (
        <ImgSelect
            // trigger reloading on sarchInfo changes!
            options={userList}
            value={curValue as any}
            //cacheOptions
            getOptionValue={getTranslatedUserName}
            onChange={usersSelected}
            isClearable={true}
            isMulti={isMulti}
            components={{
                Option: changeOption,
                SingleValue: singleValue,
                //MultiValue: changeOption,
            }}
            //            onChange={userSelected}
            isDisabled={isDisabled}
            menuPortalTarget={menuPortalTarget ?? root}
        />
    );
}
export default UserSelect;